import {
  AfterViewChecked,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import {
  AdditionalTopicScores,
  TextAndSize,
  WordCloudData,
} from '../../../../models/ai-model';
import seedrandom from 'seedrandom';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-interview-ai-wordcloud',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './interview-ai-wordcloud.component.html',
  styleUrl: './interview-ai-wordcloud.component.scss',
})
export class InterviewAiWordcloudComponent
  implements AfterViewChecked, OnChanges, OnInit
{
  @ViewChildren('canvasRef') canvasRefs!: QueryList<
    ElementRef<HTMLCanvasElement>
  >;
  @Input() wordCloudData: WordCloudData[] = [];
  @Input() isLoading: boolean = false;

  private wordcloudLibrary: any;
  wordcloud: TextAndSize[] = [];
  wordcloudsInitialized: boolean = false;
  wordcloud_additionalTopics: AdditionalTopicScores[] = [];
  wordcloud_defaultTopics: TextAndSize[] = [];

  ngOnInit(): void {
    // Load the wordcloud library dynamically only on the client-side
    if (typeof window !== 'undefined') {
      import('wordcloud').then((wordcloud) => {
        this.wordcloudLibrary = wordcloud.default;
      });
    }
  }

  ngAfterViewChecked(): void {
    console.log('ngAfterViewChecked - interview-ai-topic');
    // Controlla se le wordcloud sono già state inizializzate
    if (!this.wordcloudsInitialized) {
      if (this.canvasRefs && this.canvasRefs.length > 0) {
        this.canvasRefs.forEach((canvasRef, _index) => {
          this.createWordcloud(canvasRef.nativeElement, this.wordCloudData);
        });
        this.wordcloudsInitialized = true; // Segna che le wordcloud sono state inizializzate
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Se `aiWordcloudsSelected` cambia, resetta l'inizializzazione

    this.wordcloudsInitialized = false;
  }

  createWordcloud(canvas: HTMLCanvasElement, data: WordCloudData[]) {
    const maxFontSize = 35;
    const minScore = 15;
    const maxScore = 50;

    // Definizione dei colori
    const blueColor = 'rgb(58, 86, 158)'; // Colore per score >= 0.7
    const greenColor = 'rgb(34, 139, 34)'; // Verde per score tra 0.4 e 0.7
    const redColor = 'rgb(220, 20, 60)'; // Rosso per score < 0.4

    const getColor = (score: number) => {
      if (score >= 0.7) return blueColor;
      if (score >= 0.4) return greenColor;
      return redColor;
    };

    let wordArray: [string, number][] = data.map((item) => [
      item.word,
      item.score * maxFontSize + 15,
    ]);

    // just to test with more words
    // wordArray = wordArray.concat(wordArray.map((item) => item));
    // wordArray = wordArray.concat(
    //   data.map((item) => [item.word, item.score * maxFontSize + 15])
    // );

    canvas.style.backgroundColor = '#fffffc'; // Colore di sfondo
    canvas.style.border = '1px solid #3a569e';
    canvas.style.width = '80%';
    canvas.style.borderRadius = '20px';
    canvas.width = 1000;
    canvas.height = 500;

    const margin = 50; // Margine di sicurezza
    const innerWidth = canvas.width - margin * 2;
    const innerHeight = canvas.height - margin * 2;

    // Aggiungi seedrandom per garantire che il posizionamento sia deterministico
    const seed = 'fixed-seed'; // Un seme fisso per garantire la consistenza
    seedrandom(seed, { global: true }); // Imposta il seed globalmente

    // Creazione della word cloud con WordCloud.js
    this.wordcloudLibrary(canvas, {
      list: wordArray, // Passa la lista delle parole con le dimensioni scalate
      gridSize: Math.round((16 * canvas.width) / 1024), // Dimensioni della griglia in base alla larghezza del canvas
      color: (_word: any, weight: number) => {
        // Trova il punteggio originale corrispondente
        const score = (weight - 15) / maxFontSize;
        return getColor(score);
      },
      rotateRatio: 0.5, // 50% delle parole saranno ruotate
      rotationSteps: 2, // Parole ruotate a 0° o 90°
      backgroundColor: '#fffffc',
      drawOutOfBound: false,
      ellipticity: innerHeight / innerWidth,
    });
  }
}
